import { CreateDocumentResourceBody, CreateFileResourceBody, CreateLinkResourceBody, courseResourcesApi } from "api";
import { useToaster } from "utils";
import { ModalHeader } from "../../../components/templates/Modals/ModalHeader";
import { ModalPadding } from "../../../components/templates/Modals/ModalPadding";
import { IDropdownOption } from "components/atoms";
import { PaziaModal } from "components/molecules";
import { COURSE_RESOURCE_TYPE, LINKABLE_RESOURCE_TYPES, ResourceForm, ResourceFormValues } from "./ResourceForm";

interface AddResourceModalProps {
  onCloseRequest: () => void;
  isOpen: boolean;
  courseId: number;
  onSubmit: (newResource: { id: number; name: string; folder: string; link: string; type: number }) => Promise<void>;
  courseResourceTabId: number;
  folderOptions: IDropdownOption[];
}

export const AddResourceModal = ({
  courseId,
  onCloseRequest,
  isOpen,
  folderOptions,
  courseResourceTabId,
  onSubmit,
}: AddResourceModalProps) => {
  const { showSuccess, showError } = useToaster();

  const onLinkSubmit = async (data: CreateLinkResourceBody) => {
    try {
      const { data: newResourceId } = await courseResourcesApi.createLinkResource(courseId, courseResourceTabId, data);
      showSuccess("Materiał został dodany");
      onCloseRequest();
      onSubmit({ ...data, id: newResourceId });
    } catch (e) {
      console.error(e);
      showError("Wystąpił błąd");
    }
  };

  const onFileSubmit = async (data: CreateFileResourceBody) => {
    try {
      const { data: newResourceId } = await courseResourcesApi.createFileResource(courseId, courseResourceTabId, data);
      showSuccess("Materiał został dodany");
      onCloseRequest();
      onSubmit({ ...data, id: newResourceId, link: "", type: COURSE_RESOURCE_TYPE.INTERNAL_BLOB_FILE });
    } catch (e) {
      console.error(e);
      showError("Wystąpił błąd");
    }
  };

  const onDocumentSubmit = async (data: CreateDocumentResourceBody) => {
    try {
      const { data: newResourceId } = await courseResourcesApi.createDocumentResource(
        courseId,
        courseResourceTabId,
        data,
      );
      showSuccess("Materiał został dodany");
      onCloseRequest();
      onSubmit({ ...data, id: newResourceId, link: "", type: COURSE_RESOURCE_TYPE.DOCUMENT });
    } catch (e) {
      console.error(e);
      showError("Wystąpił błąd");
    }
  };

  const onSubmitHandler = async (data: ResourceFormValues) => {
    if (LINKABLE_RESOURCE_TYPES.includes(data.type) && data.link) {
      await onLinkSubmit({
        name: data.name,
        description: data.description ?? "",
        folder: (data.folder == "-1" ? data.newFolder : data.folder) ?? "Inne",
        link: data.link,
        type: data.type,
        sendEmail: data.sendMail,
      });
      return;
    } else if (+data.type == COURSE_RESOURCE_TYPE.INTERNAL_BLOB_FILE && data.resource) {
      await onFileSubmit({
        name: data.name,
        description: data.description ?? "",
        folder: (data.folder == "-1" ? data.newFolder : data.folder) ?? "Inne",
        resource: data.resource[0] as File,
        sendEmail: data.sendMail,
      });

      return;
    } else if (+data.type == COURSE_RESOURCE_TYPE.DOCUMENT && data.document) {
      await onDocumentSubmit({
        name: data.name,
        description: data.description ?? "",
        folder: (data.folder == "-1" ? data.newFolder : data.folder) ?? "Inne",
        document: data.document,
        sendEmail: data.sendMail,
      });
      return;
    }

    showError("Wystąpił błąd");
    console.error("Invalid form data", data);
  };

  return (
    <PaziaModal
      id="add-resource-modal"
      onCloseRequest={() => {
        onCloseRequest();
      }}
      isOpen={isOpen}
      size="xl"
    >
      {isOpen && (
        <ModalPadding>
          <ModalHeader>Dodaj materiał</ModalHeader>
          <ResourceForm
            onSubmit={onSubmitHandler}
            courseId={courseId}
            folderOptions={folderOptions}
            onCancel={() => {
              onCloseRequest();
            }}
          />
        </ModalPadding>
      )}
    </PaziaModal>
  );
};
